function Transaction() {
	return (
		<div className="text-red-600">Customer Transaction</div>
	)
}

export default Transaction